import { render, staticRenderFns } from "./AddEditNews.vue?vue&type=template&id=755e8ddb&scoped=true"
import script from "./AddEditNews.vue?vue&type=script&lang=js"
export * from "./AddEditNews.vue?vue&type=script&lang=js"
import style0 from "./AddEditNews.vue?vue&type=style&index=0&id=755e8ddb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755e8ddb",
  null
  
)

export default component.exports